import React from 'react';
import { ProtectedActionsDropdown } from '@/shared/components/Dropdown/ProtectedActionsDropdown';
import { getEnterpriseActions, EnterpriseActionsDropdownProps } from './EnterpriseActions.consts';
import { useEnterpriseStore } from '@/stores/EnterpriseStore/EnterpriseStore';

export const EnterpriseActionsDropdown: React.FC<EnterpriseActionsDropdownProps> = ({
  setIsOpen,
  enterprise,
}: EnterpriseActionsDropdownProps) => {
  const getEnterprises = useEnterpriseStore((state) => state.getItems);

  return (
    <ProtectedActionsDropdown
      actions={getEnterpriseActions({ enterprise, getEnterprises })}
      setIsOpen={setIsOpen}
    />
  );
};
